import { MutationTree } from "vuex";
import { ICompanyState } from "@/store/modules/company/state";
import { Company } from "@/types";
import { IDataProvider } from "@/store";

export enum CompanyMutations {
  SET_ONE = "SET_ONE_COMPANY",
  SET_ALL = "SET_ALL_COMPANY",
  SET_LAZY_DATA = "SET_LAZY_DATA_COMPANY",
  SET_ACTIVE_COMPANY_ID = "SET_ACTIVE_COMPANY_ID",
}

export const mutations: MutationTree<ICompanyState> = {
  [CompanyMutations.SET_ONE](state, payload: Company) {
    state.company = payload;
  },
  [CompanyMutations.SET_ALL](state, payload: Company[]) {
    state.companies = payload;
  },
  [CompanyMutations.SET_LAZY_DATA](state, payload: Company[]) {
    state.dataProvider = payload;
  },
  [CompanyMutations.SET_ACTIVE_COMPANY_ID](state, payload: string) {
    state.companyIdActive = payload;
  },
};
